import React from "react";
import PropTypes from "prop-types";
import "./DonutChart.scss";

/**
 * DonutChart — a small ring of parts with the headline in the middle. Best for two to
 * five parts where the reader wants the split at a glance (phone vs desktop).
 */
const DonutChart = ({ segments, size = 96, thickness = 14, center, sub }) => {
  const total = segments.reduce((t, s) => t + (s.value || 0), 0);
  const r = (size - thickness) / 2;
  const c = 2 * Math.PI * r;
  let offset = 0;
  return (
    <div className="donut" style={{ width: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img"
        aria-label={segments.map((s) => `${s.label} ${total ? Math.round((s.value / total) * 100) : 0}%`).join(", ")}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#f1f5f9" strokeWidth={thickness} />
        {total > 0 && segments.filter((s) => s.value).map((s) => {
          const len = (s.value / total) * c;
          const el = (
            <circle key={s.key} cx={size / 2} cy={size / 2} r={r} fill="none" stroke={s.color}
              strokeWidth={thickness} strokeDasharray={`${Math.max(len - 1, 0.5)} ${c}`}
              strokeDashoffset={-offset} transform={`rotate(-90 ${size / 2} ${size / 2})`}>
              <title>{`${s.label}: ${s.value.toLocaleString("en-GB")} (${Math.round((s.value / total) * 100)}%)`}</title>
            </circle>
          );
          offset += len;
          return el;
        })}
        {center != null && <text x="50%" y="50%" dominantBaseline="central" textAnchor="middle" className="donut__center">{center}</text>}
      </svg>
      {sub && <div className="donut__sub">{sub}</div>}
    </div>
  );
};

DonutChart.propTypes = {
  segments: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired, label: PropTypes.string.isRequired, value: PropTypes.number, color: PropTypes.string,
  })).isRequired,
  size: PropTypes.number,
  thickness: PropTypes.number,
  center: PropTypes.node,
  sub: PropTypes.node,
};

export default DonutChart;
